const esc = (s) => String(s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

const prettyDate = (s) => {
  const [y, m, d] = (s || "").split("-").map(Number);
  return y ? new Date(y, m - 1, d, 12).toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric", year: "numeric" }) : "";
};

// rows: [{ child, allergies, phone }] — one per child (paid only)
export function openSignInSheet(group, rows) {
  const list = [...rows].sort((a, b) => (a.child || "").localeCompare(b.child || ""));
  const body = list.map((r, i) => {
    const has = r.allergies && r.allergies !== "None noted";
    return `<tr><td class="n">${i + 1}</td><td class="child">${esc(r.child)}</td>
      <td class="${has ? "allergy" : "none"}">${has ? esc(r.allergies) : "None noted"}</td>
      <td>${esc(r.phone || "—")}</td><td class="box"><span></span></td></tr>`;
  }).join("");
  const blanks = Array.from({ length: Math.max(0, 3) }, (_, i) =>
    `<tr class="blank"><td class="n">${list.length + i + 1}</td><td></td><td></td><td></td><td class="box"><span></span></td></tr>`).join("");
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>Sign-in — ${esc(group.title)}</title>
<style>
  @page { size: letter; margin: 0.5in; }
  * { box-sizing: border-box; }
  body { font-family: Montserrat, Arial, sans-serif; color: #121212; margin: 0; }
  .logo { height: 40px; }
  header { display: flex; justify-content: space-between; align-items: flex-end; border-bottom: 3px solid #121212; padding-bottom: 10px; }
  h1 { font-family: Georgia, serif; font-size: 22px; margin: 6px 0 0; }
  .meta { font-size: 12px; color: #444; margin-top: 4px; }
  .count { font-size: 12px; text-transform: uppercase; letter-spacing: .15em; font-weight: bold; text-align: right; }
  table { width: 100%; border-collapse: collapse; margin-top: 14px; font-size: 13px; }
  th { text-align: left; font-size: 10px; letter-spacing: .15em; text-transform: uppercase; border-bottom: 2px solid #121212; padding: 6px; }
  td { border-bottom: 1px solid #bbb; padding: 9px 6px; vertical-align: middle; }
  td.n { width: 28px; color: #888; }
  td.child { font-weight: bold; }
  td.allergy { background: #FFE3EF; color: #B0145F; font-weight: bold; }
  td.none { color: #999; }
  td.box { width: 80px; text-align: center; }
  td.box span { display: inline-block; width: 20px; height: 20px; border: 2px solid #121212; }
  tr.blank td { height: 34px; }
  footer { margin-top: 16px; font-size: 11px; color: #666; }
  .toolbar { margin: 12px 0; } .toolbar button { padding: 8px 16px; font-weight: bold; cursor: pointer; }
  @media print { .toolbar { display: none; } }
</style></head><body>
<div class="toolbar"><button onclick="window.print()">Print / Save as PDF</button></div>
<header>
  <div><img class="logo" src="${window.location.origin}/cake-society-logo.png" alt="Cake Society" />
    <h1>${esc(group.title)}</h1>
    <div class="meta">${esc(prettyDate(group.date))}${group.time ? ` · ${esc(group.time)}` : ""}</div></div>
  <div class="count">Camp sign-in sheet<br/>${list.length} camper${list.length === 1 ? "" : "s"}</div>
</header>
<table><thead><tr><th>#</th><th>Child name</th><th>Allergies</th><th>Parent phone</th><th style="text-align:center">Checked in</th></tr></thead>
<tbody>${body}${blanks}</tbody></table>
<footer>Allergies are highlighted in pink. Blank rows are for walk-ins or last-minute additions.</footer>
<script>setTimeout(function(){ window.print(); }, 400);</script>
</body></html>`;
  const w = window.open("", "_blank");
  if (!w) return false;
  w.document.open();
  w.document.write(html);
  w.document.close();
  return true;
}
